<template>
  <div>
    <h2>My Subscriptions</h2>
    <b-table :items="subscriptions" :fields="fields" striped hover small>
      <template v-slot:cell(actions)="{ item }">
        <b-button size="sm" variant="danger" @click="confirmCancel(item)">Cancel</b-button>
      </template>
    </b-table>
    <b-modal v-model="showCancelConfirm" title="Cancel Subscription" @ok="cancelSubscription">
      Are you sure you want to cancel this subscription?
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subscriptions: [],
      fields: [
        { key: 'plan_name', label: 'Plan' },
        { key: 'status', label: 'Status' },
        { key: 'renewal_date', label: 'Renewal Date' },
        { key: 'actions', label: 'Actions' }
      ],
      showCancelConfirm: false,
      cancelingSubscription: null
    };
  },
  created() {
    this.fetchSubscriptions();
  },
  methods: {
    fetchSubscriptions() {
      this.$store.dispatch('userSubscription/fetchUserSubscriptions').then(subs => {
        this.subscriptions = subs;
      });
    },
    confirmCancel(sub) {
      this.cancelingSubscription = sub;
      this.showCancelConfirm = true;
    },
    cancelSubscription() {
      if (!this.cancelingSubscription) return;
      this.$store.dispatch('userSubscription/cancelUserSubscription', this.cancelingSubscription.id)
        .then(() => {
          this.fetchSubscriptions();
          this.showCancelConfirm = false;
          this.cancelingSubscription = null;
        });
    }
  }
};
</script>

